<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">添加/编辑个人信息</h2>
      <!-- <a href="javascript:;" @click="$router.back()" class="back-btn">返回列表</a> -->
    </div>
    <div class="form-content">
      <!-- <el-col :span="22"> -->
      <el-form ref="form" :model="form" label-width="98px" class="form">

        <human-info ref="create" :userInfo="userInfo" :formByFather="form"></human-info>

        <!-- <div class="tip" style="margin:20px 0 0 20px">
          * 相关附件
        </div>
        <div class="clear">
          <el-form-item label="上传附件">
            <attachments style="margin-left:-15px;" :projectId="form.projectId" :contractId="form.contractId"
              ref="attachments" :arr="attachmentArr" :type='990'></attachments>
          </el-form-item>
        </div> -->

        <!-- <el-form-item label=""> -->
        <div class="form-btn-room" style="margin-left:15px;">
          <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">{{formBtnText}}
          </el-button>
        </div>
        <!-- </el-form-item> -->

      </el-form>
      <!-- </el-col> -->
    </div>
  </div>
</template>


<script>
  import {
    mapState
  } from "vuex";

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'
  import HumanInfo from '@/page/form/personnel/humanInfo'
  export default {
    components: {
      ApprovalItem,
      HumanInfo,
      Attachments,
    },
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        userInfo: {},
        form: {
          // 花名册学历学校
          "hEdu": "",
          "hSchool": "",

          "archivesId": "",
          "birthAddress": "",
          "birthPlace": "",
          "birthday": "",
          "certificate": "",
          "company": "",
          "department": "",
          "dh": "",
          "email": "",
          "families": [{
            "birthday": "",
            "callName": "",
            "job": "",
            "name": "",
            "phone": "",
            "zzmm": ""
          }],
          "fullEdu": "",
          "fullSchool": "",
          "gh": "",
          "gjj": "",
          "gjjkssj": "",
          "gl": "",
          "homeAddress": "",
          "idCard": "",
          "img": "",
          "jobEdu": "",
          "jobSchool": "",
          "joinPartyTime": "",
          "joinTime": "",
          "ldhtkssj": "",
          "ldhtqx": "",
          "ldhtzzsj": "",
          "linkPhone": "",
          "linkman": "",
          "marriage": "",
          "nation": "",
          "nl": "",
          "orderNum": "",
          "phone": "",
          "position": "",
          "positions": [{
            "endTime": "",
            "startTime": "",
            "workPlace": ""
          }],
          "resumes": [{
            "endTime": "",
            "jcRecord": "",
            "startTime": "",
            "workPlace": ""
          }],
          "reward": "",
          "rxzsj": "",
          "rzsj": "",
          "sb": "",
          "sbkssj": "",
          "sex": "",
          "syzj": "",
          "tbTime": "",
          "tel": "",
          "txr": "",
          "userType": "",
          "zw": "",
          "zzTime": "",
          "zzmm": ""
        },

        // 附件
        attachmentArr: [],

        formLoading: false,

        applyInfo: '',
        formBtnText: '确认提交个人信息'
      }
    },
    created() {
      this.getUserData()
    },
    mounted() {},
    methods: {
      getUserData() {
        this.form.archivesId = this.$route.params.archivesId
        if (this.form.archivesId) {
          this.formLoading = true
          this.getUserInfo()
          this.formBtnText = "确认修改个人信息"
        }
      },
      // 获取已有个人信息
      getUserInfo() {
        ajax.get('/human/archives/detail/' + this.form.archivesId, '', (res) => {
          this.formLoading = false
          this.userInfo = res.vo.userVO
          this.form = res.vo
          if (!this.form.families || this.form.families.length < 1) {
            this.form.families = [{
              "birthday": "",
              "callName": "",
              "job": "",
              "name": "",
              "phone": "",
              "zzmm": ""
            }, ]
          }
          if (!this.form.positions || this.form.positions.length < 4) {
            if (!this.form.positions) {
              this.form.positions = []
            }
            let _length = this.form.positions.length
            for (; _length < 4; _length++) {
              this.form.positions.push({
                "endTime": "",
                "startTime": "",
                "workPlace": ""
              })
            }
          }

          if (!this.form.resumes || this.form.resumes.length < 1) {
            this.form.resumes = [{
              "endTime": "",
              "jcRecord": "",
              "startTime": "",
              "workPlace": ""
            }]
          }
        })
      },
      // 提交项目申请
      createProject() {
        this.form = this.$refs.create.getFromData()
        if(!this.form.gh || !this.form.name || !this.form.company || !this.form.department || !this.form.phone){
          this.$message.error("有必填内容尚未填写，请认真填写标红的必填项")
          return false
        }


        this.form.json = true

        this.formLoading = true

        let _url = '/human/archives/add'
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.archivesId) {
            this.$message.success("提交个人个人信息成功")
          } else {
            this.$message.success("修改个人个人信息成功")
          }
          this.$router.push("/Personnel/List")
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      "$route"() {
        this.getUserData()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/personnel/humanInfo.vue